import { Toaster } from 'react-hot-toast';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from '@v2/design-system';
import I18nProvider from './providers/I18nProvider';
import QueryProvider from './providers/QueryProvider';
import { AppRouter } from './router';

export default function App() {
    return (
        <ThemeProvider>
            <QueryProvider>
                <I18nProvider>
                    <BrowserRouter basename="/">
                        <AppRouter />
                    </BrowserRouter>
                </I18nProvider>
                <Toaster position="top-right" toastOptions={{ className: 'text-sm' }} />
            </QueryProvider>
        </ThemeProvider>
    );
}
